module.exports = __webpack_public_path__ + "img/ring_g_skip_0_0.711b097f.png";